import { getDashboardData } from "apis";
import { useQuery } from "react-query";

const DashboardComponent = () => {
    const { data, isLoading } = useQuery(
        ["dashboard"],
        () => getDashboardData(),
    );

    const stats = data?.data.data;

    const cards = [
        { title: "가입자 수", value: stats?.userCount ?? '-', unit: "명", icon: "👥", color: "bg-blue-50 text-blue-600", borderColor: "border-blue-100" },
        { title: "활성 서비스", value: stats?.serviceCount ?? '-', unit: "건", icon: "🛒", color: "bg-emerald-50 text-emerald-600", borderColor: "border-emerald-100" },
        { title: "총 예약", value: stats?.bookingCount ?? '-', unit: "건", icon: "📅", color: "bg-purple-50 text-purple-600", borderColor: "border-purple-100" },
        { title: "대기 문의", value: stats?.faqCount ?? '-', unit: "건", icon: "💬", color: "bg-rose-50 text-rose-600", borderColor: "border-rose-100" },
        { title: "신고 접수", value: stats?.reportCount ?? '-', unit: "건", icon: "🚨", color: "bg-amber-50 text-amber-600", borderColor: "border-amber-100" },
        { title: "출금 요청", value: stats?.withdrawRequestCount ?? '-', unit: "건", icon: "💰", color: "bg-cyan-50 text-cyan-600", borderColor: "border-cyan-100" },
    ];

    if (isLoading) {
        return (
            <div className="p-8">
                <div className="animate-pulse flex flex-col gap-6">
                    <div className="h-8 bg-achromatic-100 rounded w-40" />
                    <div className="grid grid-cols-3 gap-5">
                        {[...Array(6)].map((_, i) => (
                            <div key={i} className="h-[140px] bg-achromatic-100 rounded-2xl" />
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="p-8">
            {/* Header */}
            <div className="mb-8">
                <h1 className="text-2xl font-extrabold text-achromatic-900">대시보드</h1>
                <p className="text-sm text-achromatic-400 mt-1">서비스 운영 현황을 한눈에 확인하세요</p>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-3 gap-5">
                {cards.map((card) => (
                    <div
                        key={card.title}
                        className={`bg-white rounded-2xl border ${card.borderColor} p-6 hover:shadow-lg transition-shadow duration-200`}
                    >
                        <div className="flex items-center justify-between mb-4">
                            <span className={`inline-flex items-center justify-center w-10 h-10 ${card.color} rounded-xl text-lg`}>
                                {card.icon}
                            </span>
                        </div>
                        <div className="text-3xl font-extrabold text-achromatic-900 mb-1">
                            {card.value}
                            <span className="text-sm font-semibold text-achromatic-400 ml-1">{card.unit}</span>
                        </div>
                        <div className="text-[13px] text-achromatic-500 font-medium">{card.title}</div>
                    </div>
                ))}
            </div>

            {/* Quick Info */}
            <div className="mt-8 bg-white rounded-2xl border border-achromatic-100 p-6">
                <h2 className="text-base font-bold text-achromatic-900 mb-4">시스템 정보</h2>
                <div className="grid grid-cols-2 gap-4">
                    <div className="flex items-center gap-3 p-3 bg-achromatic-50 rounded-xl">
                        <span className="text-base">🟢</span>
                        <div>
                            <div className="text-[13px] font-semibold text-achromatic-700">서버 상태</div>
                            <div className="text-[12px] text-achromatic-400">정상 운영 중</div>
                        </div>
                    </div>
                    <div className="flex items-center gap-3 p-3 bg-achromatic-50 rounded-xl">
                        <span className="text-base">📅</span>
                        <div>
                            <div className="text-[13px] font-semibold text-achromatic-700">마지막 접속</div>
                            <div className="text-[12px] text-achromatic-400">{new Date().toLocaleString('ko-KR')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardComponent;